import { FeatureMouseInteraction } from '@shared/openlayers/interaction/FeatureMouseInteraction';
import { MapOverlays } from '@openlayers/ol-overlays';
import { setMapCursor } from '@openlayers/ol-utils';
import Feature from 'ol/Feature';
import { LabelService } from '@shared/services/LabelService';
import { showTekPointSoilSurvey } from '@pages/soil-survey/soil-survey-main';
import { SURVEY_TYPE_TITLES } from '@pages/soil-survey/soil-survey-constants';

export class TekPointDesktopMouseInteraction extends FeatureMouseInteraction {
    onClick = (feature: Feature, e, n, featuresAtPixel: Feature[]): void => {
        const html = [];
        featuresAtPixel.forEach((f, index) => {
            html.push(this.getDialogHTML(f, index));
        });
        MapOverlays.showDialog(
            this.map,
            "<div class='right'><i class='iki iki-cross' onclick='mapUI.hideDialog()'></i></div>" +
                '<div id="tek-info-popup" class="padded-half" style="max-height: 40vh; overflow-y: auto; overflow-x: hidden;">' +
                html.join('<hr>') +
                '</div>',
            e,
            n
        );

        setTimeout(() => {
            const headings = document.querySelectorAll('.tek-heading');

            headings.forEach((heading: HTMLElement) => {
                const featureIndex = parseInt(heading.getAttribute('data-index') || '0');
                const clickedFeature = featuresAtPixel[featureIndex];

                heading.addEventListener('click', () => {
                    if (clickedFeature) {
                        const pointData = clickedFeature.get('data');
                        this.handleTekPointClick(pointData.props);
                    }
                });
            });
        }, 100);
    };

    handleTekPointClick(pointData: any) {
        const tt = pointData['tutkimustapa'];

        if (!tt) {
            console.log('No TT found in point data');
            return;
        }

        const parsedValue = tt.split(/[\s-]/)[0];
        const title = SURVEY_TYPE_TITLES[parsedValue];

        if (title) {
            showTekPointSoilSurvey({
                ...pointData,
                title,
            });
        } else {
            console.log('Unknown TT type:', parsedValue);
        }
    }

    onMouseOver = (feature: Feature): void => {
        if (!feature.get('data').isLinePoint) {
            setMapCursor(this.map, 'pointer');
        }
    };

    getDialogHTML(feature: Feature, index: number) {
        const point = feature.get('data');

        // Create a heading with a unique ID and data attribute
        const headingHTML = `
            <div class="tek-heading-container">
                <h3 class="tek-heading" data-index="${index}" id="tek-heading-${index}"
                    style="cursor: pointer; display: inline-block; color: #0066cc;">
                    Pohjatutkimus
                    <i class="iki iki-external" style="font-size: 0.8em; margin-left: 5px;"></i>
                </h3>
            </div>
        `;

        return headingHTML + LabelService.getHTMLLabelForTekPoint(point);
    }
}
